function applyImageClassChanges() {
  /*const presets = [
    [2, 6, 7, 10],
    [3, 5, 9, 11],
    [2, 4, 7, 10],
    [2, 4, 8, 11],
    [3, 4, 6, 7]
  ];*/


  const presets = [
    [2, 6, 11, 14],
    [3, 5, 10, 15],
    [2, 6, 11, 13],
    [2, 5, 8, 13],
    [3, 7, 9, 14]
  ];

  const randomNumbers = presets[Math.floor(Math.random() * presets.length)];

  randomNumbers.forEach(number => {
    const wrapper = document.querySelector(`.ab-editorial-grid #gf-grid ul div:nth-child(${number}) .spf-product-card__image-wrapper`);
    if (!wrapper) return;

    const images = wrapper.querySelectorAll('img');
    images.forEach(img => {
      img.classList.remove(
        'spf-product-card__image-main',
        'spf-product-card__image-secondary'
      );
      img.classList.add('spf-product-card__image-hidden');
    });

    setTimeout(function () {
      const imgMain = wrapper.querySelector('img:nth-child(2)');
      if (imgMain) {
        imgMain.classList.add('spf-product-card__image-main');
        imgMain.classList.remove('spf-product-card__image-hidden');
      }

      const imgSecondary = wrapper.querySelector('img:nth-child(3)');
      if (imgSecondary) {
        imgSecondary.classList.add('spf-product-card__image-secondary');
        imgSecondary.classList.remove('spf-product-card__image-hidden');
      }
    }, 200);
  });
}

window.addEventListener('load', () => {
  applyImageClassChanges();
});

(function () {
  let lastUrl = location.href;

  const observeUrlChange = function () {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      setTimeout(() => {
        applyImageClassChanges();
      }, 800);
    }
  };

  const pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(history, arguments);
    observeUrlChange();
  };

  const replaceState = history.replaceState;
  history.replaceState = function () {
    replaceState.apply(history, arguments);
    observeUrlChange();
  };

  window.addEventListener('popstate', observeUrlChange);

  const observer = new MutationObserver(observeUrlChange);
  observer.observe(document.body, { childList: true, subtree: true });
})();
